import { all, call, put, takeLatest } from 'redux-saga/effects'
import { callApiAsync } from 'services/api/callAPIAsync'
import { getUser, getUserError, getUserSuccess, setUser } from './reducer'

function* userCallSaga() {
    const { data, error } = yield call(callApiAsync, 'getAccount')

    if (error) {
        console.error('userCallSaga', 'INTERNAL_ERROR')
        yield put(getUserError())
        return
    }

    yield put(setUser(data))
    yield put(getUserSuccess())
}

export default function* userSaga() {
    yield all([takeLatest(getUser.type, userCallSaga)])
}
